import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useMediaQuery, useTheme } from '@mui/material';
import { Grid, Typography } from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  value: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
}));

const getLabelVariant = (bold: boolean, ish4: boolean = false) => {
  switch (true) {
    case ish4:
      return 'h4';
    case bold:
      return 'h5';
    default:
      return 'body1';
  }
};

interface FeeRowProps {
  bold?: boolean;
  label: string;
  value: string;
  containerClassName?: string;
  valueClassName?: string;
  labelClassName?: string;
  ish4?: boolean;
}

const FeeRow = ({
  bold = false,
  label,
  value,
  containerClassName,
  valueClassName,
  labelClassName,
  ish4,
}: FeeRowProps) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const labelVariant = getLabelVariant(bold, ish4);
  return (
    (<Grid
      md={12}
      xs={12}
      container
      direction="row"
      justify="flex-start"
      className={containerClassName}
    >
      <Grid xs={12} sm={9} md={6}>
        <Typography
          noWrap
          display="block"
          variant={labelVariant}
          align="left"
          className={labelClassName}
        >
          {label}
        </Typography>
      </Grid>
      <Grid
        container
        xs={12}
        sm={3}
        md={2}
        direction="row"
        justify={isMobile ? 'flex-start' : 'flex-end'}
      >
        <Typography
          noWrap
          display="block"
          variant={labelVariant}
          align="left"
          id={`span-${label.replace(/\s/, '-')}-value`}
          className={valueClassName || classes.value}
        >
          {`S$${value}`}
        </Typography>
      </Grid>
    </Grid>)
  );
};

export default FeeRow;
